mutation SendMessage($message: String!, $chatId: ID) {
  sendChatMessage(message: $message, chatId: $chatId) {
    chat {
      id
    }
    chatMessage {
      id
      content
      role
    }
    streamSessionUuid
  }
}
